/**
 * 展示会商談予約カレンダーの初期化
 */
export function initVisitorReservationIndex() {
    const article = document.getElementById("visitor-reservation-index");
    if (article === null)
        return;
    initSelectButtons();
}
/**
 * 「○予約可」ボタンの初期化
 */
function initSelectButtons() {
    const buttons = document.querySelectorAll('[id^="select-button-"]');
    for (const button of buttons) {
        button.addEventListener("click", function () {
            const selectId = button.dataset.id;
            const selectDate = button.dataset.date;
            submit(selectId, selectDate);
        });
    }
}
function submit(id, date) {
    const idInput = document.createElement("input");
    idInput.type = "hidden";
    idInput.name = "reservation_frame_id";
    idInput.value = id;
    const dateInput = document.createElement("input");
    dateInput.type = "hidden";
    dateInput.name = "reservation_date_str";
    dateInput.value = date;
    const form = document.getElementById("select-form");
    form.appendChild(idInput);
    form.appendChild(dateInput);
    form.submit();
    form.removeChild(idInput);
    form.removeChild(dateInput);
}
